export const getTagType = (value: string) => {
  if (value !== undefined) {
    const formattedValue = value.toLowerCase();
    const alertSecondary = ['sem act', 'pendente', 'programado', 'em análise', 'aguardando análise', 'pagamento pendente', 'há pagamentos pendentes', 'em dia'];
    const error = ['acp inativa', 'acp inativo', 'atrasado', 'pagamento atrasado', 'rejeitado', 'em atraso'];
    const errorSecondary = ['inativo', 'expirado'];
    const success = ['acp ativa', 'acp ativo', 'ativo'];
    const successSecondary = ['ativa', 'analisado', 'ativo', 'aprovado', 'feito', 'a vencer', 'contestação', 'disponível', 'act ativa', 'quitado'];
    if (alertSecondary.includes(formattedValue)) return 'alertSecondary';
    if (error.includes(formattedValue)) return 'error';
    if (errorSecondary.includes(formattedValue)) return 'errorSecondary';
    if (success.includes(formattedValue)) return 'success';
    if (successSecondary.includes(formattedValue)) return 'successSecondary';
    return 'default';
  }
  return 'default';
};

export default getTagType;
